import styled, { css } from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import colors from '@decisiv/design-tokens/lib/color';

const blackSheep = toColorString(colors.base.blackSheep);

const darkScrollbar = css`
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${blackSheep};
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.35);
  }

  scrollbar-color: rgba(255, 255, 255, 0.2) ${blackSheep};
  scrollbar-width: thin;
`;

export const PageContainer = styled.div`
  display: flex;
  height: 100vh;
`;

export const NavColumnContainer = styled.div`
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const LeftNavContainer = styled.div<{ isExpanded?: boolean }>`
  flex: 1;

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      overflow: auto;
      ${darkScrollbar}
    `}

  ${({ isExpanded }) =>
    !isExpanded &&
    css`
      /* In collapsed (icon) mode, anchor the popover to the viewport so it
         never extends below the visible area, and scroll internally. */
      ul ul {
        position: fixed;
        top: 0;
        max-height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;
        ${darkScrollbar}
      }
    `}
`;

export const PrimaryContentContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  position: relative;
`;

export const TopNavContainer = styled.div`
  width: 100%;
`;
